import intl from 'react-intl-universal';

export const getEventTypesOptions = () => [
  {
    value: '1',
    code: 'ilt',
    label: intl.get('SCHEDULE.EVENTS.DETAILS_SECTION.EVENT_TYPES.ILT'),
  },
  {
    value: '2',
    code: 'vilt',
    label: intl.get('SCHEDULE.EVENTS.DETAILS_SECTION.EVENT_TYPES.VILT'),
  },
  {
    value: '3',
    code: 'hybrid',
    label: intl.get('SCHEDULE.EVENTS.DETAILS_SECTION.EVENT_TYPES.HYBRID'),
  },
];

export const colors = [
  '#5957a9',
  '#367d2f',
  '#5e2863',
  '#dc822c',
  '#0073e6',
  '#8c6264',
  '#4f3489',
  '#0f574d',
  '#3e617d',
  '#aa4b72',
  '#a64817',
  '#2546f0',
  '#6f2419',
  '#32337f',
  '#687f1a',
  '#323d5f',
  '#b51963',
  '#2546f0',
  '#aa0606',
  '#166a60',
  '#246d8b',
  '#c44e52',
  '#596882',
];

export const HOLIDAY_EVENT_COLOR = '#438A7E';
export const HOLIDAY_EVENT_BACKGROUND_COLOR = '#B9DDD6';
